import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface menuPages {
  currentPage?: string;
}

const MenuLateral: React.FC<menuPages> = ({ currentPage }) => {
  const navigate = useNavigate();

  const page = currentPage ?? null;

  const handledevolution = () => {
    navigate("/devolution");
  };
  const handleNewQuery = () => {
    navigate("/order");
  };
  const handleInfo = () => {
    navigate("/info");
  };

  return (
    <Box display={"flex"} flexDirection={"column"} borderRight={"1px solid #E3E3E3"} pr={1}>
      <button onClick={handledevolution} style={{ border: "none", background: "none", cursor: "pointer" }}>
        <div className={`menuItem ${page === "devolution" ? "currentPage" : null}`}>
          <p>Acompanhar Solicitação</p>
        </div>
      </button>
      <button onClick={handleNewQuery} style={{ border: "none", background: "none", cursor: "pointer" }}>
        <div className={`menuItem ${page === "request" ? "currentPage" : null}`}>
          <p>Nova Solicitação</p>
        </div>
      </button>
      <button onClick={handleInfo} style={{ border: "none", background: "none", cursor: "pointer" }}>
        <div className={`menuItem ${page === "info" ? "currentPage" : null}`}>
          <p>Informações e Instruções</p>
        </div>
      </button>
    </Box>
  );
};
export default MenuLateral;
